export default __webpack_public_path__ + "static/media/pearl-connect.f7d19094.svg";